import OutlinedFlagIcon from "@mui/icons-material/OutlinedFlag";
import { Box } from "@mui/material";
import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { supplierTableRow } from "../../types/index"
import { useStyles } from "./styles";

type Props = {
  rows: supplierTableRow[] | undefined;
  loading?: boolean;
};

  const SupplierTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();
  

  const columns = useMemo(
    () => [
      {
        id: "headline",
        label: t("SUPPLIERS.TABLE.NOTES"),
        minWidth: 100,
        align: "right",
        format: (row: supplierTableRow) => row.headline,
      },
      {
        id: "phoneOffice",
        label: t("SUPPLIERS.TABLE.OFFICE_NUMBER"),
        minWidth: 90,
        align: "right",
      },
      {
        id: "address",
        label: t("SUPPLIERS.TABLE.ADDRESS"),
        minWidth: 140,
        align: "right",
        format: (row: supplierTableRow) => row.address,
      },
      {
        id: "contact",
        label: t("SUPPLIERS.TABLE.CONTACT"),
        minWidth: 160,
        align: "right",
        format: (row: supplierTableRow) => row.contact,
      },
      {
        id: "fax",
        label: t("SUPPLIERS.TABLE.FAX"),
        minWidth: 160,
        align: "right",
      },
      {
        id: "telephone",
        label: t("SUPPLIERS.TABLE.NUMBER"),
        minWidth: 160,
        align: "right",
      },
      {
        id: "vendorName",
        label: t("SUPPLIERS.TABLE.SUPPLIER_NAME"),
        minWidth: 160,
        align: "right",
        format: (row: supplierTableRow) => row.vendorName,
      },
      {
        id: "vendorID",
        label: t("SUPPLIERS.TABLE.CODE"),
        minWidth: 160,
        align: "right",
      }
    ],
    [styles, t]
  );

  return (
    <div className={styles.root}>
      <DataTable
        rows={rows || []}
        columns={columns}
        loading={loading}
        serialEnabled={false}
        isPointerCursor
      />
    </div>
  );
};

export default SupplierTable;
